export default __webpack_public_path__ + "static/media/danger.e88984e6.mp3";